import React, { Fragment } from 'react';
import _ from 'lodash';
import styles from './style.js';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { MUValidatorForm } from 'basic-components';
import Button from '../ui/Button';
import MUTypography from '../ui/MUTypography';
import { bindActionCreators } from 'redux';
import * as apiDashboardService from '../../services/apidashboardservice';
import * as Actions from '../../redux/actions';
import ApplicationInfo from './ApplicationInfo';
import TokenInfo from './TokenInfo';
import APIsInfo from './APIsInfo';
import IpList from './IpList';
import { getProducts as getProductsSelect } from '../../redux/selectors';
import MUCircularProgress from '../ui/MUCircularProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import Popup from "reactjs-popup";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InfoIcon from '@mui/icons-material/Info';
import "./index.css";
import { TextField, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { generateRsaKeys } from './RsaKey/index.js';

class NewApplication extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      editPage: false,
      readOnly: false,
      id: '',
      name: '',
      description: '',
      icon: '',
      selectedProducts: [],
      redirectUri: '',
      publickey: '',
      tempPrivateKey: '',
      clientId: '',
      clientSecret: '',
      checked: [],
      products: [],
      selectedFile: null,
      file: '',
      ipList: [],
      onServiceCall: true,
      loading: false,
      otpNeeded: false
    };
  }

  generateRsaKeys = async () => {
    try {
      const { publicKeyBase64, privateKeyBase64 } = await generateRsaKeys();
      this.setState({ publickey: publicKeyBase64, tempPrivateKey: privateKeyBase64 });

      setTimeout(() => {
        this.setState({ tempPrivateKey: '' });
      }, 15000);
    } catch (error) {
      console.error("RSA key üretim hatası:", error);
    }
  };

  addIpToList = (ip) => {
    this.setState({
      ipList: [...this.state.ipList, ip]
    });
  };

  deleteIpFromList = (ip) => {
    let temp = [...this.state.ipList];

    let index = temp.indexOf(ip);

    temp.splice(index, 1);
    this.setState({ipList: temp});
  };

  resetForm = () => {
    this.setState({
      editPage: false,
      readOnly: false,
      id: '',
      name: '',
      description: '',
      icon: '',
      selectedProducts: [],
      redirectUri: '',
      publickey: '',
      tempPrivateKey: '',
      clientId: '',
      clientSecret: '',
      checked: [],
      ipList: [],
      otpNeeded: false,
    });
  }

   componentDidUpdate(prevProps) {
     // Reset form when entering new application mode (not edit)
     if (this.props.newapplication && !this.props.editapplication) {
       if (!prevProps.newapplication || prevProps.editapplication) {
         this.resetForm();
       }
     }
   }

  componentWillMount() {
    const productList = this.props.selectProducts;

    if (this.props.location.state !== undefined && this.props.editapplication) {
      // state passed from history.push
      const { appId, applications, readOnly } = this.props.location.state;

      Array.prototype.forEach.call(applications, value => {

        if (value.id === appId) {
          this.setState({
            editPage: true,
            id: value.id,
            readOnly: readOnly,
            name: value.name,
            description: value.description,
            redirectUri: value.oauthRedirectUri,
            publickey: value.publicKey,
            clientId: value.oauthClientId,
            clientSecret: value.oauthClientSecret,
            checked: value.productList,
            icon: value.icon,
            ipList: value.ipList,
            otpNeeded: value.otpNeeded
          });
        }
      });
    }

    if (!_.isEmpty(productList)) {
      this.setState({ products: productList, onServiceCall: false});
    } else {
      this.getProducts();
    }
  }

  getProducts() {
    apiDashboardService.getProducts()
      .then((responseJson) => {
        if (responseJson.data) {
          this.setState({ products: responseJson.data});
          this.props.actions.addProducts(responseJson.data);
        }
      })
      .catch((exception) => {
        // TODO: Show Generic Error to user - System error occured, please try again
      })
      .finally(()=>{
        this.setState({ onServiceCall: false });
      });
  }

  handleChange = (field, value) => {
    this.setState({ [field]: value });
  };

  handleToggle = (checked) => {
    this.setState({ checked: checked });
  };

  handleSubmit = () => {
    this.setState({
      selectedProducts: [...this.state.checked],
      loading: true
    });

    this.saveApplication();
  }

  saveApplication = () => {
    const { id, name, description, icon, redirectUri, publickey, clientId, clientSecret, checked, ipList, otpNeeded } = this.state;

    apiDashboardService.saveApplication(id, name, description, icon, checked,
      redirectUri, publickey, clientId, clientSecret, ipList, otpNeeded)
      .then((responseJson) => {

        this.redirectToApplications();
      }).catch((error) => {
        if (_.isNil(error.response)) {
          if (!_.isNil(error.message)) {
            this.props.actions.setNotification(error.message, 'error');
          } else {
            this.props.actions.setNotification('System error occured', 'error');
          }
          return;
        }

        error.response.json()
          .then(r => {
            this.props.actions.setNotification(r.header.message, 'error');
          });
      })
      .finally(()=>{
        this.setState({loading: false});
      });
  }

  redirectToApplications() {
    this.props.history.push('/');
    this.props.history.push('/dashboard?page=applications');
  }

  renewTokens = (clientId, clientSecret, editPage) => {
    this.setState({
      editPage: editPage,
      clientId: clientId,
      clientSecret: clientSecret
    });
  }

  fileChangedHandler = (iconBytes) => {
    this.setState({
      icon: iconBytes
    });
  }

  onApplicationInfoLoad = (id, name, description, redirectUri, publickey) =>{
    this.setState({
      id: id,
      name: name,
      description: description,
      redirectUri: redirectUri,
      publickey: publickey
    });
  }

  onIpListLoad = (ipList) => {
    this.setState({ipList: ipList});
  }

  onTokenInfoLoad = (clientId, clientSecret) =>{
    this.setState({clientId: clientId, clientSecret: clientSecret});
  }

  onAPIsInfoLoad = (productList) => {
    this.setState({ checked: productList});
  }

  onIconLoad = (icon) => {
    this.setState({icon: icon});
  }

  onOtpNeededSwitch = (target) => {
    this.setState({otpNeeded: target});
    this.setState({showModal:true})
  }

  Card(){
    return (
    <div className="card">
      <div className="header">Sağ position </div>
      <div className="content">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit autem
        sapiente labore architecto exercitationem optio quod dolor cupiditate
      </div>
    </div>)
  }

  render() {
    const {readOnly, loading, onServiceCall, otpNeeded, tempPrivateKey} = this.state;
    const {classes, editapplication} = this.props;

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column'
      }}>
        {this.props.open ?
          <div>
            {editapplication ?
              <MUTypography className= {classes.appType} variant='h4'>
  Edit Application
              </MUTypography> : <MUTypography className= {classes.appType} variant='h4'>
  New Application
              </MUTypography>}

            <br/>
            {
              onServiceCall ?
                <div style={{ display: 'flex', justifyContent: 'center'}}>
                  <MUCircularProgress className={this.props.classes.progress} size={50}></MUCircularProgress>
                </div> :
                <div>
                  <MUValidatorForm
                    onSubmit={this.handleSubmit}
                  >
                    <div id='applicationInfo'>
                      <ApplicationInfo
                          key={`appinfo-${this.props.editapplication}`}
                          {...this.props}
                          handleChange={this.handleChange}
                          fileChangedHandler={this.fileChangedHandler}
                          onApplicationInfoLoad={this.onApplicationInfoLoad}
                          onIconLoad={this.onIconLoad}
                          publickey={this.state.publickey}
                      />

                      {!readOnly && (
                          <Button
                              text='Generate Keys'
                              type="button"
                              onClick={this.generateRsaKeys}
                              classes={{ root: classes.btnRefreshToken, text: classes.txtRefreshToken, label: classes.label }}
                              color="secondary"
                              disabled={readOnly} />

                      )}
                      <div style={{ height: '16px' }} />


                      {tempPrivateKey && (
                          <div >
                            <MUTypography
                                variant="subtitle1"
                                gutterBottom
                                classes={{ root: classes.warningText }}
                            >
                              THIS PRIVATE KEY WILL BE DISPLAYED ONLY ONCE AND WILL DISAPPEAR IN 15 SECONDS.<br />
                              PLEASE STORE IT IN A SECURE LOCATION.
                            </MUTypography>


                            <div style={{
                              display: 'flex',
                              gap: '8px',
                              alignItems: 'flex-start',
                              marginLeft: '10px',
                              width: '103%',
                            }}>
                              <TextField
                                  value={tempPrivateKey}
                                  multiline
                                  rows={5}
                                  fullWidth
                                  variant="outlined"
                                  InputProps={{
                                    readOnly: true,
                                    style: {
                                      fontFamily: 'monospace',
                                      backgroundColor: '#f5f5f5',
                                      borderRadius: '6px'
                                    }
                                  }}
                              />
                              <Tooltip title="Copy to clipboard">
                                <IconButton
                                    onClick={() => navigator.clipboard.writeText(tempPrivateKey)}
                                    sx={{ height: '80px', alignSelf: 'center' }}
                                >
                                  <ContentCopyIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                            <div style={{ height: '16px' }} />

                          </div>
                      )}
                    </div>
                      <div id= 'ipList' style={{width: '100%', float: 'left'}}>
                        <IpList key={`iplist-${this.props.editapplication}`}
                          {...this.props}
                          handleChange = {this.handleChange}
                          addIpToList= {this.addIpToList}
                          deleteIpFromList = {this.deleteIpFromList}
                          onIpListLoad = {this.onIpListLoad}/>
                      </div>
                      <div style={{width: "100%", overflow: "hidden"}}>
                        <div style={{float: "left"}}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={otpNeeded}
                              onChange={e => this.onOtpNeededSwitch(e.target.checked)}
                              name="otpNeeded"
                              color="primary"
                            />
                          }
                          label="Otp Needed?"
                          labelPlacement="start"
                        />

                        </div>
                        <Popup
                          trigger={<IconButton> <InfoIcon sx={{ fontSize: 20 }} style={{marginTop:'6px'}}/> </IconButton>}
                          position="right center"
                          contentStyle={{width: "300px", backgroundColor: '#ED502E66' }}
                          on="hover"
                          className="my-modal"
                        >
                           <div className="card" style={{backgroundColor:'#F0F0F0'}}>
                            <div className="header">What is OTP NEEDED?</div>
                            <div className="content">
                            If you make OTP Needed inactive, the client still get an OTP for authorization and client credentials flow.
                            You just decide OTP should come for password flow or not.
                            This means; you are just activating otp for password flow.
                            </div>
                            </div>
                        </Popup>
                    </div>
                    {editapplication ?
                      <TokenInfo key={`tokeninfo-${this.props.editapplication}`}
                        {...this.props} renewTokens = {this.renewTokens} onTokenInfoLoad={this.onTokenInfoLoad} /> : null}

                    <div >
                      <APIsInfo key={`apisinfo-${this.props.editapplication}`}
                        {...this.props} handleToggle={this.handleToggle} onAPIsInfoLoad = {this.onAPIsInfoLoad}/>
                    </div>

                    <div>
                      {readOnly ? null :
                        <Button
                          classes={{ root: classes.btnRefreshToken, text: classes.txtRefreshToken, label: classes.label }}
                          disabled={loading}
                          text = {editapplication ? 'Save' : 'Add' }
                          type = "submit"
                          style = {{width: '100%'}}
                        >
                        </Button>
                      }
                      {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>

                  </MUValidatorForm>
                </div>
            }
          </div> :
          null}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

const mapStateToProps = state => ({
  products: state.products,
  selectProducts: getProductsSelect(state)
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles))(NewApplication);
